import React from 'react';
import { motion } from 'framer-motion';
import { SearchIcon, AccessibilityIcon, CodeIcon, GaugeIcon, LayersIcon, PencilRulerIcon } from 'lucide-react';
const FEATURES = [{
  icon: SearchIcon,
  title: 'SEO-Driven',
  description: 'Every site is built to rank for the searches families use, from "assisted living near me" to your specific levels of care.'
}, {
  icon: AccessibilityIcon,
  title: 'Accessible for All',
  description: 'Accessibility is more than adding a plugin. We build to WCAG 2.2 guidelines, which matters more when your audience skews older.'
}, {
  icon: CodeIcon,
  title: 'Custom WordPress Development',
  description: 'No restrictive themes. Custom coded around your community, care levels, and floor plans.'
}, {
  icon: GaugeIcon,
  title: 'Performance-Focused',
  description: 'Fast load times and true mobile responsiveness, because most family research happens on a phone.'
}, {
  icon: LayersIcon,
  title: 'Scalable',
  description: 'Add communities, care levels, or locations without a rebuild.'
}, {
  icon: PencilRulerIcon,
  title: 'Easy to Edit',
  description: 'A clean back end plus training, so your team can post events and open positions without calling us.'
}];
export function FeaturesSection() {
  return <section className="w-full bg-[var(--color-navy)]" data-id="element-71" data-mp="1uv8p6oyiywhc">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 sm:px-6 sm:py-20 lg:px-8" data-id="element-72" data-mp="1qu6rick9ashh">
        <div className="mx-auto max-w-3xl text-center" data-id="element-73" data-mp="134cdvss44zw6">
          <h2 className="font-display text-2xl font-bold text-white sm:text-3xl" data-id="element-74" data-mp="13548b09z4rkv">
            WordPress Websites Built for Occupancy and Recruitment
          </h2>
          <p className="mt-4 text-base text-white/70 sm:text-lg" data-id="element-75" data-mp="1c6lmgd3tmj6x">
            Six things every senior living website we build has in common.
          </p>
        </div>
        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-76" data-mp="2nkfohq5szq3n">
          {FEATURES.map((feature, i) => <motion.div key={feature.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.45,
          delay: i * 0.06
        }} className="rounded-2xl border border-white/10 bg-[var(--color-navy-light)] p-7 transition-shadow hover:shadow-lg" data-id="element-77" data-mp="2ime6l8k45wtr" data-mpi={i}>
              <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-xl bg-[var(--color-navy)]" data-id="element-78" data-mp="1u7g0ab645eyx">
                <feature.icon className="h-6 w-6 text-[var(--color-lime)]" aria-hidden="true" data-id="element-79" data-mp="xjjp5ltg3bv3" />
              </div>
              <h3 className="font-display text-lg font-bold text-white" data-id="element-80" data-mp="11gxx7a5e3dli">
                {feature.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-white/70" data-id="element-81" data-mp="1b8u151u5pxxn">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}